var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 19,
    viewBox: "0 0 6 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 16.9762C1.2 15.9701 2.01648 15.1529 3.0237 15.1529C4.03092 15.1529 4.84741 15.9703 4.84741 16.9762C4.84741 17.9834 4.03096 18.7999 3.0237 18.7999C2.01645 18.7999 1.2 17.9834 1.2 16.9762Z",
    fill: "#FF544F",
    stroke: "black",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77589 0.2L4.32119 12.9541H1.67881L0.224108 0.2H5.77589Z",
    fill: "#FF544F",
    stroke: "black",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarked);
export default __webpack_public_path__ + "static/media/marked.06e945b12f288543d7f81ac49d51a58a.svg";
export { ForwardRef as ReactComponent };